import { Typography } from '@mui/material';
import React from 'react';
import { useAttributeStyles } from 'components/Modals/QCPassFailModal/styles';

export const AttributeLink = ({ label, value, link }) => {
  const { classes } = useAttributeStyles();

  if (!value || !link) {
    return null;
  }

  return (
    <div className={classes.marginBottom05RemStyle}>
      <Typography className={classes.inlineBlockNormalStyle}>
        {' '}
        {label}
        {' : '}
      </Typography>{' '}
      <Typography className={classes.inlineBlockBoldStyle}>
        <a
          href={link}
          target={'_blank'}
          rel="noopener noreferrer"
          className={classes.noDecorationLink}
        >
          {value}
        </a>
      </Typography>
    </div>
  );
};
